var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFzDialogue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 26V10H2v31h10v12.27L26.75 41H29v16h20.28L64 69.27V57h10V26H47zM29.12 37H25.3L16 45v-8H6V14h37v12H29.12v11zM70 53H60v7.73L50.72 53H33V41h14V30h23v23z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/FZ_Dialogue.4f604675.svg";
export { SvgFzDialogue as ReactComponent };